import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'


export function getStateOld() {
  return Cookies.get("oldstate")
}

export function setStateOld() {
  return Cookies.set("oldstate", false)
}

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getTokenTime() {
  return Cookies.get('tokenTime')
}

export function setTokenTime(tokenTime) {
  return Cookies.set('tokenTime', tokenTime)
}

export function removeTokenTime() {
  return Cookies.remove('tokenTime')
}


export function setExplanatoryType(type ) {
  return  Cookies.set('explanatoryType', type)
}
export function getExplanatoryType() {
  return Cookies.get('explanatoryType')
}
export function removeExplanatoryType() {
  return Cookies.remove('explanatoryType')
}


export function h2ms(time) {  // 小时 => 毫秒
  return time*60*60*1000;
}


// 对象深拷贝
export function DeepClone (obj) {
  if(typeof obj == 'object' && obj != null) {
    let cloneObj = new obj.constructor();
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        cloneObj[key] = DeepClone(obj[key]);
      }
    }
    return cloneObj;
  } else {
    return obj
  }
}